export default __webpack_public_path__ + "static/media/top-ten-8.42e67c83.svg";